<template>
  <v-main>
    <v-container fluid>
      <v-row class="ma-0">
        <!-- Creamos las migas de pan automaticamente -->

        <v-spacer></v-spacer>
        <!-- Tutoriales de youtube -->
        <Tutoriales/>
      </v-row>

      <!-- Generamos el AppBar con las distintas acciones -->
      <v-app-bar color="primary" dense dark style="border-radius: 5px">
        <!-- Crear una nueva tarjeta fidelidad -->
        <v-btn text @click="open_dialog_tarjeta_fidelidad()">
          <v-icon>mdi-card-plus-outline</v-icon>
          <span class="appbar_button">{{ $t("Nueva") }}</span>
        </v-btn>
      </v-app-bar>

      <!-- Mensaje informativo -->
      <div class="container_info_azul">
        {{ $t("Una tarjeta de fidelidad es una tarjeta precargada que puede usarse para realizar el pago de un importe de una venta y además lleva asociado un descuento a productos y a servicios que se aplicarán a la venta antes de descontar el importe de la tarjeta.") }}
        {{ $t("Para que una tarjeta de fidelidad pueda ser usada, primero debe de ser vendida a un cliente.") }}
      </div>

      <!-- Filtro de busqueda -->
      <v-expansion-panels focusable class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header class="titulo_buscador">
            <span>
              <v-icon large>mdi-magnify</v-icon>
              {{ $t("Buscar") }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="ma-0" align="center">
              <v-col class="pb-0" cols="12" sm="4" md="2">
                <v-text-field
                    v-model="selected_filters.ref__icontains"
                    :label="$t('Referencia')"
                    dense
                    outlined
                    hide-details
                >
                </v-text-field>
              </v-col>

              <v-col class="pb-0" cols="12" sm="4" md="3">
                <v-text-field
                    v-model="selected_filters.nombre__icontains"
                    :label="$t('Nombre')"
                    dense
                    outlined
                    hide-details
                >
                </v-text-field>
              </v-col>

              <v-col class="pb-0" cols="12" sm="4" md="3">
                <DatePickerRange
                    v-model="data_filters.created"
                    :title="$t('Fecha')"
                    dense
                    outlined
                />
              </v-col>

              <v-col class="pb-0" cols="12" sm="4" md="2">
                <CustomSelect
                    v-model="data_filters.is_active"
                    :items="data_filters.boolean_filter"
                    :label="$t('Activo')"
                    :hide_details="true"
                />
              </v-col>

              <v-col class="pt-6 text-end" sm="4" md="2">
                <v-btn fab small right class="primary" @click.prevent="get_tarjetas_fidelidad">
                  <v-icon small>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Tabla de tarjetas fidelidad -->
      <TablaTarjetasFidelidad
          ref="tabla_tarjetas_fidelidad"
          :selected_filters="selected_filters"
          @on_click_edit="open_dialog_tarjeta_fidelidad"
          :is_venta="false"
      />
    </v-container>

    <!-- Dialog de tarjeta fidelidad con el formulario -->
    <FormTarjetaFidelidad
        v-if="dialog_tarjeta_fidelidad"
        v-model="dialog_tarjeta_fidelidad"
        :item="current_tarjeta_fidelidad"
        @on_save="on_save_tarjeta_fidelidad"
    />
  </v-main>
</template>

<script>
export default {
  name: "TarjetaFidelidad",
  data: () => ({
    current_tarjeta_fidelidad: null,
    dialog_tarjeta_fidelidad: false,

    // Variables para rellenar los selects de los filtros
    data_filters: {
      boolean_filter: [],
      created: [],
      is_active: [],
    },

    // Los filtros seleccionados
    selected_filters: {
      ref__icontains: "",
      nombre__icontains: "",
      created_by__id__in: "[]",
      is_active: [true]
    },

  }),

  methods: {
    /**
     * Recupera las tarjetas de fidelidad de la api
     */
    async get_tarjetas_fidelidad() {
      this.selected_filters.created__date__gte = this.data_filters.created[0]
      this.selected_filters.created__date__lte = this.data_filters.created[1]

      if(this.data_filters.is_active.length === 1){
        this.selected_filters.is_active = this.data_filters.is_active[0]
      }else{
        this.selected_filters.is_active = ""
      }

      await this.$refs.tabla_tarjetas_fidelidad.get_tarjetas_fidelidad()
    },

    /**
     * Abre el formulario del tarjeta_fidelidad
     */
    open_dialog_tarjeta_fidelidad(item) {
      this.current_tarjeta_fidelidad = {
        is_active: true
      }

      if(item){
        this.current_tarjeta_fidelidad = {...item }
      }

      this.dialog_tarjeta_fidelidad = true
    },

    /**
     * Al guardar la tarjeta fidelidad
     */
    on_save_tarjeta_fidelidad(){
      this.get_tarjetas_fidelidad()
      this.dialog_tarjeta_fidelidad = false
    }

  },

  mounted() {
    this.data_filters.boolean_filter = [
      { text: this.$t("Si"), value: true },
      { text: this.$t("No"), value: false }
    ]
    // Fechas filtro
    this.data_filters.created.push(this.$moment().add(-3, 'month').format('yyyy-MM-DD'))
    this.data_filters.created.push(this.$moment().format('yyyy-MM-DD'))
  },

  components: {
    TablaTarjetasFidelidad: () => import('@/views/Marketing/TarjetasFidelidad/components/TablaTarjetasFidelidad'),
    FormTarjetaFidelidad: () => import('@/views/Marketing/TarjetasFidelidad/components/FormTarjetaFidelidad'),
  }
}
</script>
